export default __webpack_public_path__ + "static/data-vis-chart-data-light-d0878a5d1c71d945680ab8abbcb342cd.png";